import LingokidsApplication from '../../resources/images/lingokids_application.png';
import Oxford from '../../resources/images/oxford.png';
import { useEffect, useState } from 'react';
import LingokidsApplicationModal from './LingokidsApplicationModal';
import { checkPhoneNumber, setOnlyNumbers } from '../../utils/validationUtils';
import PersonalInformation from './PersonalInformation';
import LingokidsApplicationResultModal from './LingokidsApplicationResultModal';
import LingokidsFavicon from '../../resources/favicons/lingokids_favicon.ico';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';

const Lingokids = () => {
  const [showApplicationModal, setShowApplicationModal] = useState(false);
  const [showApplicationResultModal, setShowApplicationResultModal] = useState(false);
  const [showPersonalInformationModal, setShowPersonalInformationModal] = useState(false);
  const [checked, setChecked] = useState(false);
  const [formData, setFormData] = useState({
    phoneNumber: '',
  });
  const [message, setMessage] = useState();
  const [searchParams] = useSearchParams();

  // usagePeriod 파라미터 가져오기.
  const usagePeriodParam = searchParams.get('usagePeriod') || '2';

  const openApplicationModal = (data) => {
    setShowApplicationModal(true);
  };

  const closeApplicationModal = () => {
    setShowApplicationModal(false);
  };

  const openApplicationResultModal = (e) => {
    setMessage(e);
    setShowApplicationResultModal(true);
  };

  const closeApplicationResultModal = () => {
    setShowApplicationResultModal(false);
  };

  const handleFormData = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const openPersonalInformationModal = (data) => {
    setShowPersonalInformationModal(true);
  };

  const closePersonalInformationModal = () => {
    setShowPersonalInformationModal(false);
  };

  const openModal = () => {
    // alert('현재 링고키즈 2일 체험권 오류 발생으로 인하여 잠시, 사전 체험 신청 페이지를 중단합니다. 이용에 불편을 드려 죄송합니다.')
    // return

    if (!checked) {
      alert('개인정보 수집 및 이용동의을 확인하고 동의하신다면 체크해 주세요.');
      return;
    } else if (formData.phoneNumber === '') {
      alert('폰 번호를 입력해 주세요.');
      return;
    } else if (!checkPhoneNumber(setOnlyNumbers(formData.phoneNumber))) {
      alert('폰 번호 형식을 확인해 주세요.');
      return;
    }
    openApplicationModal();
  };

  const handleCheck = (e) => {
    if (e.target.checked) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  };

  useEffect(() => {
    if (showApplicationModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showApplicationModal]);

  useEffect(() => {
    if (showApplicationResultModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showApplicationResultModal]);

  useEffect(() => {
    if (showPersonalInformationModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [showPersonalInformationModal]);

  // useEffect(() => {
  //   alert('현재 링고키즈 2일 체험권 오류 발생으로 인하여 잠시, 사전 체험 신청 페이지를 중단합니다. 이용에 불편을 드려 죄송합니다.')
  // }, [])

  return (
    <div className={'flex justify-center'}>
      <Helmet>
        <title>Lingokids</title>
        <link rel={'icon'} href={LingokidsFavicon}/>
      </Helmet>
      <LingokidsApplicationModal showApplicationModal={showApplicationModal}
                                 closeApplicationModal={closeApplicationModal}
                                 data={formData}
                                 parentUsagePeriodParam={usagePeriodParam}
                                 openApplicationResultModal={openApplicationResultModal}/>
      <LingokidsApplicationResultModal showApplicationResultModal={showApplicationResultModal} closeApplicationResultModal={closeApplicationResultModal} message={message}/>
      <PersonalInformation showPersonalInformationModal={showPersonalInformationModal} closePersonalInformationModal={closePersonalInformationModal}/>
      <div className={'max-w-[500px]'}>
        <div>
          <img src={LingokidsApplication} alt={'LingokidsApplication'}/>
        </div>
        <div className={'bg-[#ffcadf]'}>
          <div className={'flex justify-center pt-[20px]'}>
            <input type={'text'} name={'phoneNumber'} value={formData.phoneNumber || ''} onChange={handleFormData}
                   className={'w-[300px] border-[2px] border-[#1a1f41] rounded-[10px] h-[60px] text-center font-[nanum-square-b] text-[24px]'} placeholder={'010-0000-0000'}/>
          </div>
          <div className={'flex justify-center font-[nanum-square-b] mt-[20px]'}>
            <div className={'text-[#1a1f41] flex items-center'}>
              <input type={'checkbox'} id={'checked'} checked={checked} onChange={(e) => handleCheck(e)} className={'flex items-center w-[18px] h-[18px]'}/>
              <label htmlFor={'checked'}>
                <div className={'ml-[6px]'}>개인정보 수집 및 이용동의(필수)</div>
              </label>
            </div>
            <button type={'button'} onClick={openPersonalInformationModal} className={'flex items-center text-[#666666] underline underline-offset-4 decoration-2 text-[12px] ml-[10px]'}>상세보기</button>
          </div>
          <div className={'flex justify-center mt-[20px]'}>
            <button type={'button'} onClick={openModal} className={'border border-[#1a1f41] bg-[#1a1f41] text-[#ffffff] font-[nanum-square-round-eb] text-[24px] w-[260px] h-[60px] rounded-[10px]'}>신청
              하기
            </button>
          </div>
          <div className={'flex justify-center font-[nanum-square-b] text-[14px] mt-[10px] text-[#a37688]'}>
            * 링고키즈 2일 체험권은 60일마다 신청이 가능합니다.
          </div>
          <div className={'flex justify-center mt-[30px] pb-[20px]'}>
            <img src={Oxford} alt={'Oxford'} className={'w-[150px]'}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lingokids;